<template>

  <!-- eslint-disable  -->

  <div class="">

    <!-- background -->
    <div class="z-10 w-full h-screen bg-blue-900 fixed opacity-75" >

    </div>


    <!-- image -->
    <div v-if="this.$store.state.opengallery !== 0" class="z-20 fixed w-full h-full" >

      <div class="mx-auto rounded-lg opacity-100" >

        <!-- <button class="bg-orange-300 p-4 m-6 text-black absolute text-center right-0 mr-10 mt-10 cursor-pointer" @click="closegallery()"> GALERIE SCHLIESSEN</button> -->

        <!-- <h1 class=""> {{ this.$store.state.opengallery.titel }}</h1> -->

        <div class="pb-8 mx-auto mt-4 max-h-1/2">

          <img class="rounded-none mx-auto maxheight" v-if="currentimage == 0" :src="this.$store.state.opengallery.galerie[0].url" alt="">

          <img class="rounded-none mx-auto maxheight" v-else :src="this.currentimage" alt="">

        </div>

      </div>

      <!-- image navigation bar -->
      <div class="flex flex-1 overflow-x-auto">

        <div class="w-1/3 p-1 cursor-pointer" :key="image.id" v-for="image in this.$store.state.opengallery.galerie">

          <div class="container">

            <img class="rounded-none h-32 w-full object-cover rounded-lg" @click="viewthis(image.id)" :src="image.url" alt="">

          </div>

        </div>

        <button class="bg-orange-300 p-4 m-6 text-black absolute text-center bottom-0 right-0 cursor-pointer" @click="closegallery()"> <i class="fas fa-times"></i> SCHLIESSEN</button>

      </div>




    </div>

  </div>


</template>

<script>

export default {
  components: {

  },
  name: 'OpenGallery',
  props: {

  },
  data() {
    return {

      actualYear: '',
      actualDate: '',
      opengallery: '',
      currentimage: 0,

    }
  },
  methods: {

    viewthis(id){

      var result = this.$store.state.opengallery.galerie.filter(obj => {
        return obj.id == id;
      })

      this.currentimage = result[0].url;

    },

    closegallery(){

      this.$store.commit('closegallery');

    },

    convert(old){

      // console.log("nodedate:" + old);

      var monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"];

      // console.log(old)

      var yyyy = old.slice(0, 4)
      // console.log("Actual:" + yyyy);
      // console.log("This:" + this.actualYear)

      var mm = old.slice(4, 6)
      mm = parseInt(mm)

      var dd = old.slice(6, 8)

      if (yyyy == this.actualYear){
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      } else {
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      }
    },

    getdate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();

      // console.log(today = dd + '. ' + monthNames[mm] + ' ' + yyyy);

      this.actualYear = yyyy;
      this.actualDate = yyyy + mm + dd

      // console.log("DATUM IST" + this.actualDate);
    },

  },
  mounted: function(){

    this.getdate();

  },

  computed: {

    getOpenGallery() {


      return'hallo'
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.container{
  width: 200px;
}

.maxheight{

  max-height: 500px;
}

</style>
